__turbopack_context__.v({
  "container": "footer-module-scss-module__C1bfHa__container",
  "content": "footer-module-scss-module__C1bfHa__content",
  "logo": "footer-module-scss-module__C1bfHa__logo",
  "poweredBy": "footer-module-scss-module__C1bfHa__poweredBy",
});
